import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import { toCamelcaseKeys } from 'lib/string'

export type GetRequirementPositionsRequest = {
  requirementId: number
  cursor?: string
  direction?: 'next' | 'previous'
  pageSize?: number
}

export type RequirementPosition = {
  company: {
    id: number
    name: string
  }
  id: number
  mustHave: boolean
  name: string
}

export type GetRequirementPositionsResponse = {
  items: RequirementPosition[]
  previousCursor: string | null
  nextCursor: string | null
}

export const getRequirementPositions = async (
  request: GetRequirementPositionsRequest
): Promise<GetRequirementPositionsResponse> => {
  const { requirementId, cursor, direction, pageSize } = request
  const response = await api.get(
    `/admin/requirement/${requirementId}/positions`,
    {
      params: {
        cursor,
        direction,
        page_size: pageSize,
      },
      paramsSerializer: queryParamSerializer,
    }
  )

  // `toCamelcaseKeys` is used to convert the cursor to camelCase
  return toCamelcaseKeys(response.data, {
    deep: true,
  }) as GetRequirementPositionsResponse
}
